{
  "nl": {
    "constants": {
      "address": {
        "city": "Stad",
        "country": "Land",
        "number": "Nummer",
        "street": "Straat",
        "zip": "Postcode"
      },
      "crud": {
        "created_at": "Aangemaakt op",
        "deleted_at": "Verwijderd op",
        "updated_at": "Gewijzigd op"
      },
      "currencies": {
        "all": "Alle munten",
        "popular": "Populair"
      },
      "days": ["Zon", "Ma", "Di", "Woe", "Do", "Vr", "Za"],
      "languages": {
        "de": "Duits",
        "en": "Engels",
        "fallback_info": "Het lijkt erop dat dit niet beschikbaar is in jouw taal. We gebruiken in plaats daarvan een bestaande vertaling in het {fallback_locale}.",
        "fr": "Frans",
        "nl": "Nederlands",
        "pl": "Pools",
        "pt": "Portugees"
      },
      "languages_short": {
        "de": "DE",
        "en": "EN",
        "fr": "FR",
        "nl": "NL",
        "pl": "PL",
        "pt": "PT"
      },
      "measurements": {
        "imperial": "Imperial",
        "metric": "Metrisch",
        "surface": {
          "imperial": "Sq. ft",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "Januari",
        "Februari",
        "Maart",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "December"
      ],
      "profile_statuses": {
        "active": "Actief",
        "added": "Niet uitgenodigd",
        "blocked": "Gedeactiveerd",
        "discarded": "Verwijderd",
        "invited": "Uitgenodigd",
        "invited_at": "Uitgenodigd"
      },
      "profile_statuses_descriptive": {
        "active": "Laatste keer actief op het platform: {session_ended_at}",
        "added": "Nog niet uitgenodigd",
        "blocked": "Gedeactiveerd",
        "discarded": "Verwijderd",
        "invited": "Uitgenodigd maar nog niet aangemeld",
        "invited_at": "Uitgenodigd {invited_at}. Nog niet aangemeld"
      },
      "profile_titles": {
        "dr": "Dokter",
        "mr": "Heer",
        "mrs": "Mevrouw",
        "professor": "Professor",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Dagen",
        "months": "Maanden",
        "weeks": "Weken"
      },
      "time_units_count": {
        "days": "geen dag | dag | dagen",
        "months": "geen maand | maand | maanden",
        "weeks": "geen week | week | weken"
      },
      "timezone_regions": {
        "Africa": "Afrika",
        "America": "Amerika",
        "Asia": "Azië",
        "Atlantic": "Atlantische Oceaan",
        "Australia": "Australië",
        "Europe": "Europa",
        "Pacific": "Stille Oceaan"
      },
      "timezones": {
        "Africa/Abidjan": "Afrika/Abidjan",
        "Africa/Cairo": "Afrika/Caïro",
        "Africa/Casablanca": "Afrika/Casablanca",
        "Africa/Johannesburg": "Afrika/Johannesburg",
        "Africa/Lagos": "Afrika/Lagos",
        "Africa/Nairobi": "Afrika/Nairobi",
        "America/Anchorage": "Amerika/Anchorage",
        "America/Bogota": "Amerika/Bogota",
        "America/Buenos_Aires": "Amerika/Buenos Aires",
        "America/Chicago": "Amerika/Chicago",
        "America/Denver": "Amerika/Denver",
        "America/Halifax": "Amerika/Halifax",
        "America/Lima": "Amerika/Lima",
        "America/Los_Angeles": "Amerika/Los Angeles",
        "America/Mexico_City": "Amerika/Mexico-Stad",
        "America/New_York": "Amerika/New York",
        "America/Phoenix": "Amerika/Phoenix",
        "America/Santiago": "Amerika/Santiago",
        "America/Sao_Paulo": "Amerika/São Paulo",
        "America/St_Johns": "Amerika/St. John's",
        "America/Toronto": "Amerika/Toronto",
        "America/Vancouver": "Amerika/Vancouver",
        "Asia/Bangkok": "Azië/Bangkok",
        "Asia/Colombo": "Azië/Colombo",
        "Asia/Dhaka": "Azië/Dhaka",
        "Asia/Dubai": "Azië/Dubai",
        "Asia/Ho_Chi_Minh": "Azië/Ho Chi Minh",
        "Asia/Hong_Kong": "Azië/Hongkong",
        "Asia/Jakarta": "Azië/Jakarta",
        "Asia/Karachi": "Azië/Karachi",
        "Asia/Kolkata": "Azië/Kolkata",
        "Asia/Kuala_Lumpur": "Azië/Kuala Lumpur",
        "Asia/Makassar": "Azië/Makassar",
        "Asia/Manila": "Azië/Manila",
        "Asia/Riyadh": "Azië/Riyad",
        "Asia/Seoul": "Azië/Seoel",
        "Asia/Shanghai": "Azië/Shanghai",
        "Asia/Singapore": "Azië/Singapore",
        "Asia/Taipei": "Azië/Taipei",
        "Asia/Tehran": "Azië/Teheran",
        "Asia/Tokyo": "Azië/Tokio",
        "Atlantic/Reykjavik": "Atlantische Oceaan/Reykjavik",
        "Australia/Adelaide": "Australië/Adelaide",
        "Australia/Brisbane": "Australië/Brisbane",
        "Australia/Darwin": "Australië/Darwin",
        "Australia/Hobart": "Australië/Hobart",
        "Australia/Melbourne": "Australië/Melbourne",
        "Australia/Perth": "Australië/Perth",
        "Australia/Sydney": "Australië/Sydney",
        "Europe/Amsterdam": "Europa/Amsterdam",
        "Europe/Athens": "Europa/Athene",
        "Europe/Belgrade": "Europa/Belgrado",
        "Europe/Berlin": "Europa/Berlijn",
        "Europe/Brussels": "Europa/Brussel",
        "Europe/Bucharest": "Europa/Boekarest",
        "Europe/Budapest": "Europa/Boedapest",
        "Europe/Copenhagen": "Europa/Kopenhagen",
        "Europe/Dublin": "Europa/Dublin",
        "Europe/Helsinki": "Europa/Helsinki",
        "Europe/Istanbul": "Europa/Istanbul",
        "Europe/Lisbon": "Europa/Lissabon",
        "Europe/London": "Europa/Londen",
        "Europe/Madrid": "Europa/Madrid",
        "Europe/Moscow": "Europa/Moskou",
        "Europe/Oslo": "Europa/Oslo",
        "Europe/Paris": "Europa/Parijs",
        "Europe/Prague": "Europa/Praag",
        "Europe/Rome": "Europa/Rome",
        "Europe/Stockholm": "Europa/Stockholm",
        "Europe/Vienna": "Europa/Wenen",
        "Europe/Warsaw": "Europa/Warschau",
        "Europe/Zurich": "Europa/Zürich",
        "Pacific/Auckland": "Stille Oceaan/Auckland",
        "Pacific/Fiji": "Stille Oceaan/Fiji",
        "Pacific/Honolulu": "Stille Oceaan/Honolulu"
      },
      "wind_orientations": {
        "east": "Oostelijk",
        "north": "Noord",
        "northeast": "Noordoost",
        "northwest": "Noordwest",
        "select": "Selecteer Oriëntatie",
        "south": "Zuid",
        "southeast": "Zuidoost",
        "southwest": "Zuidwest",
        "west": "Westelijk"
      }
    }
  }
}
